document.addEventListener("DOMContentLoaded", function () {

    let link = document.querySelector('.JS-estate-form-show'),
        form = document.querySelector('.JS-estate-form'),
        button = document.querySelector('.JS-estate-form-close'),
        formMessages = form.querySelector('.messagess');

    link.addEventListener('click', function () {
        form.classList.add('is-active');
    });

    button.addEventListener('click', function () {
        form.classList.remove('is-active');
    });

    if (formMessages) {
        let id = formMessages.id;
        if (window.location.href.indexOf(id) > -1) {
            form.classList.add('is-active');
        }
    }
});